import React from 'react';
import { useSelector } from 'react-redux';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useNavigate } from 'react-router-dom';
import Label from '@/components/form/Label/Label';

const LoginSuccessModal = ({ open, loginType }) => {
  const navigate = useNavigate();

  const onGoBack = () => {
    navigate(-1);
  };
  const languageData = useSelector(state => state.lenguage?.lang);
  if (!open) return null;

  return (
    <FlexContainer
      className="pos-fixed justify-center align-items-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      <FlexContainer
        className="pos-rel flex-column align-center width-300px bgWhite borderrad26 overflow-hidden"
        style={{
          boxShadow: '0px 8px 26px rgba(0,0,0,0.25)',
        }}
      >
        <FlexContainer className="width-100 justify-center align-items-center padt8 padr0 padb10 padl0 pos-rel bgGradientBlue">
          <i
            className="fas fa-circle-check"
            style={{
              fontSize: '48px',
              color: '#ffffff',
            }}
          />
        </FlexContainer>

        <FlexContainer className="flex-column align-center text-center padlr26 padt26 padb22">
          <Label
            className="text-20 font-medium margb14"
            style={{ color: '#0143a0', lineHeight: '1.4' }}
          >
            {loginType === 'google'
              ? languageData === 'EN'
                ? 'Login successful with Google'
                : 'Inicio de sesión con Google exitoso'
              : loginType === 'register'
                ? languageData === 'EN'
                  ? 'Registration successful'
                  : 'Registro exitoso'
                : languageData === 'EN'
                  ? 'Login successful'
                  : 'Inicio de sesión exitoso'}
          </Label>

          <Label
            className="text-16 font-regular margb26"
            style={{ color: '#0143a0', lineHeight: '1.4' }}
          >
            {loginType === 'google'
              ? languageData === 'EN'
                ? 'You’re now logged in. Book your next workspace in under 60 seconds.'
                : 'Ya iniciaste sesión. Reserva tu próximo espacio de trabajo en menos de 60 segundos. Sin membresías. Solo acceso simple.'
              : loginType === 'register'
                ? languageData === 'EN'
                  ? 'You have successfully registered and successfully logged in.'
                  : 'Te has registrado correctamente y has iniciado tu sesión automáticamente.'
                : languageData === 'EN'
                  ? 'You’re now logged in. Book your next workspace in under 60 seconds.'
                  : 'Ya iniciaste sesión. Reserva tu próximo espacio de trabajo en menos de 60 segundos. Sin membresías. Solo acceso simple.'}
          </Label>

          <FlexContainer
            onClick={onGoBack}
            className="pointer justify-center align-items-center borderrad10 padtb12 padlr0 margb12 bgGradientSignUpPurple"
            style={{
              width: '100%',

              boxShadow: '0px 2px 6px rgba(2, 59, 122, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={e => (e.currentTarget.style.background = '#023B7A')}
            onMouseLeave={e => (e.currentTarget.style.background = '#0143a0')}
          >
            <Label className="text-16 font-bold" style={{ color: '#FFF' }}>
              {languageData === 'EN' ? 'Ok' : 'Aceptar'}
            </Label>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default LoginSuccessModal;
